<div>
  <!--
  <div class="text-center my-8">
    <p class="" i18n="Photo input">Odložite vaše fotografije v spodnji prostor</p>
  </div>
  -->

  <div class="grid mb-2 mt-1" *ngIf="images.length && showGrid"
       [ngClass]="{'justify-between': images.length > 2}" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onDrop($event)">

    <ng-container *ngFor="let item of images; let i = index">
      <div [ngClass]="{'sm:w-64': i === 0 && images.length === 1}" cdkDrag [cdkDragDisabled]="isMobile">
        <ng-container *ngIf="item.upload; else showLoadingPhoto">
          <div class="relative">
            <img [ngClass]="{
                  'border-2 border-primary': checkIfItemSelected(item) != -1,
                  'opacity-40': isAdvertisingSelectable() && !isAdvertised(item),
                  }"
                 class="border border-0 hover:border-2 hover:border-primary cursor-pointer photo object-cover rounded w-full"
                 [src]="item.upload.files?.[0]?.conversions?.thumbnail ?? item.upload.files?.[0]?.url"
                 alt="picture is loading ..."
                 loading="lazy"
                 (click)="onItemSelectChange(item)">

            <div class="absolute photo pointer-events-none w-full h-full photo-overlay top-0"></div>
            <div
                    class="absolute rounded-lg w-8 h-8 flex justify-center text-white items-center top-0 left-0 mt-2 ml-2 text-sm backdrop-blur-sm"
                    style="background: rgba(0, 0, 0, 0.4)">{{ i + 1 }}
            </div>
            <button (click)="removeFile(item)" type="button"
                    class="absolute rounded-lg w-8 h-8 shadow-lg hover:shadow-xl flex justify-center text-red items-center hover:scale-105 transition-all duration-300 ease-out top-0 right-0 mt-2 mr-2 backdrop-blur-sm">
              <i class="fas fa-times text-sm"></i></button>

            @if (isCarPeakPhoto(item)) {
            <div class="absolute top-0 left-0 mt-12 ml-2 rounded px-1.5 py-0.5 text-xs font-semibold backdrop-blur-sm pointer-events-none"
                 style="background: rgba(0, 0, 0, 0.4); color: #EEC120" i18n>★ CARPEAK</div>
            }

            @if (isAdvertisingSelectable()) {
            <button (click)="toggleAdvertise(item)" type="button"
                    [ngClass]="isAdvertised(item) ? 'text-primary' : 'text-grayDark'"
                    [title]="isAdvertised(item) ? advertiseOnTitle : advertiseOffTitle"
                    class="absolute rounded-lg w-8 h-8 shadow-lg hover:shadow-xl flex justify-center items-center hover:scale-105 transition-all duration-300 ease-out top-0 right-0 mt-10 mr-2 backdrop-blur-sm bg-white/70">
              <i class="fas text-sm" [ngClass]="isAdvertised(item) ? 'fa-bullhorn' : 'fa-ban'"></i></button>
            }

            @if (!isBackgroundRemovalField()) {
            <button (click)="moveBack(item)" type="button"
                    *ngIf="i < images.length - 1 && images.length > 1"
                    class="absolute rounded-lg w-11 h-11 md:w-14 md:h-14 shadow-lg hover:shadow-xl flex justify-center text-primary bg-gradient-to-br from-white to-gray-50 items-center hover:scale-105 hover:from-primary/5 hover:to-primary/15 transition-all duration-300 ease-out bottom-0 right-0 mb-3 mr-3 backdrop-blur-sm">
              <i class="fas fa-chevron-right text-lg md:text-xl"></i></button>

            <div
                    *ngIf="i === 0"
                    class="absolute rounded w-10 h-10 flex justify-center h items-center bottom-0"
                    style="color: #EEC120; margin-bottom: 0.75rem; left: 50%; transform: translateX(-50%)"><i class="fas fa-star text-xl md:text-2xl"></i>
            </div>

            <button (click)="moveForward(item)" type="button"
                    *ngIf="i > 0"
                    class="absolute rounded-lg w-11 h-11 md:w-14 md:h-14 shadow-lg hover:shadow-xl flex justify-center text-primary bg-gradient-to-br from-white to-gray-50 items-center hover:scale-105 hover:from-primary/5 hover:to-primary/15 transition-all duration-300 ease-out bottom-0 left-0 mb-3 ml-3 backdrop-blur-sm">
              <i class="fas fa-chevron-left text-lg md:text-xl"></i></button>
            }
          </div>
        </ng-container>

        <ng-template #showLoadingPhoto>
          <div class="photo bg-grayNavi rounded border border-gray relative" style="padding-top: 100%">
            <div class="absolute w-full h-full flex justify-center flex-col top-0 items-center">
              <app-spinner></app-spinner>
              <div class="mt-3 text-black text-sm" i18n="File upload">Nalagam...</div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>

  @if (!isMaxReached) {
  <div class="mt-3 mb-4">
    <div ngx-dropzone (change)="onSelect($event)" [multiple]="true"
         class="dropzone briefd-photos-dropzone"
         [accept]="'image/jpeg,image/jpg,image/png,image/gif,image/heic,image/heif,.jpg,.jpeg,.png,.gif,.heic,.heif'"
         [attr.data-field]="field?.fieldUuid"
         [attr.data-typeId]="field?.config?.typeId"
         [ariaLabel]="field?.config?.label"
         [maxFileSize]="(field?.config?.maxFileSize || 10240) * 1024">
      <ngx-dropzone-label>
        <div class="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 py-2">
          <div class="briefd-photos-dropzone__icon">
            <i class="fas fa-cloud-upload-alt"></i>
          </div>
          <div class="text-sm text-center sm:text-left leading-relaxed">
            <span class="block text-black font-bold text-base mb-0.5">
              @if (field?.config?.typeId === FieldTypeEnum.BRIEFD_VEHICLE_EXTERNAL_IMAGE_BACKGROUND_REMOVAL) {
                <span i18n="@@carpeak.bg-removal.dropzone">Mesto za odlaganje fotografij za CarPeak odstranitev ozadja</span>
              } @else {
                <span i18n>Mesto za odlaganje fotografij</span>
              }
            </span>
            <span class="text-grayDark" i18n="Photo upload">S klikom na to mesto lahko tudi <span
                    class="text-primary font-medium hover:underline">izberete fotografije</span>.</span>
          </div>
        </div>
      </ngx-dropzone-label>
    </div>
  </div>
  }

  @if (rejectedFileMessages.length) {
  <div class="mb-3 rounded border border-red px-3 py-2 text-sm text-red" role="alert">
    @for (message of rejectedFileMessages; track $index) {
    <div class="flex items-start gap-2">
      <i class="fas fa-exclamation-circle mt-0.5"></i>
      <span>{{ message }}</span>
    </div>
    }
  </div>
  }

  <ul class="briefd-photos-hints">
    @if (maxImages) {
    <li [ngClass]="isMaxReached ? 'text-orange-500 font-semibold' : ''">
      <i class="fas fa-images"></i>
      {{ images.length }}/{{ maxImages }} <span i18n="Photo input">fotografij</span>
    </li>
    }
    <li>
      <i class="fas fa-weight"></i>
      <span i18n="file input">Največja dovoljena velikost datoteke je</span> {{ (field?.config?.maxFileSize || 10240) / 1024 | number:'1.0-0' }} MB
    </li>
    <li>
      <i class="fas fa-file-image"></i>
      <span i18n="Photo input">Dovoljene so le fotografije (formati: jpg, jpeg, png, gif).</span>
    </li>
    <!-- Reorder hint is an affordance tip, not a warning — grouped with
         the other hints in the same muted style. -->
    <li>
      <i class="fas fa-arrows-alt"></i>
      <span i18n>Fotografije lahko tudi povlečete in spustite za spremembo vrstnega reda.</span>
    </li>
    @if (isAdvertisingSelectable()) {
    <li>
      <i class="fas fa-bullhorn"></i>
      <span i18n>Z ikono megafona izberete, katere fotografije se uporabijo za oglaševanje. Zatemnjene fotografije niso objavljene na portalih.</span>
    </li>
    }
  </ul>
  <div>
    <app-field-errors [control]="control" [field]="field" [hasToBeTouched]="false"></app-field-errors>
  </div>
</div>
